/**
 * @generated SignedSource<<3a8cfc2d5ac5c81dd83d5ad66864ec20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EmailVisibilityTypeEnum = "organisation" | "private" | "shared";
export type UpdateEmailThreadVisibilityInput = {
  clientMutationId?: string | null;
  id: string;
  visibility: EmailVisibilityTypeEnum;
};
export type FeedItemVisibilityMutation$variables = {
  input: UpdateEmailThreadVisibilityInput;
};
export type FeedItemVisibilityMutation$data = {
  readonly updateEmailThreadVisibility: {
    readonly clientMutationId: string | null;
  } | null;
};
export type FeedItemVisibilityMutation = {
  response: FeedItemVisibilityMutation$data;
  variables: FeedItemVisibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateEmailThreadVisibilityPayload",
    "kind": "LinkedField",
    "name": "updateEmailThreadVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedItemVisibilityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedItemVisibilityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40084d77ce9ef92d275e0be2637630a0",
    "id": null,
    "metadata": {},
    "name": "FeedItemVisibilityMutation",
    "operationKind": "mutation",
    "text": "mutation FeedItemVisibilityMutation(\n  $input: UpdateEmailThreadVisibilityInput!\n) {\n  updateEmailThreadVisibility(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "79fdc2d9618e37faeefe9f9793c79ab8";

export default node;
